import { styled } from "@mui/system";

const ParagraphContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    '@media (max-width: 1024px)': {
        gap: '2px',
    }
});

const ParagraphTitle = styled('p')({
    color: '#00E378',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '18px',
    marginBottom: '4px',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '16px',
        marginBottom: '2px',
    }
});

const ParagraphText = styled('p')({
    color: '#F1F7F7',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '16px',
    }
});

export const DevExParagraph = ({ title, text }: { title: string, text: string }) => {
    return (
        <ParagraphContainer>
            <ParagraphTitle>
                {title}
            </ParagraphTitle>
            <ParagraphText>
                {text}
            </ParagraphText>
        </ParagraphContainer>
    );
};